import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominasNominaDocumentosCfdiGenerador', {
    template: template,
    controller: nominasNominaDocumentosCfdiGeneradorComponent,
    bindings: {
      data: '<',
      archivo: '<',
      onClose: '&',
    },
  })

function nominasNominaDocumentosCfdiGeneradorComponent($file, $zip) {
  let $ctrl = this,
    max = 3

  $ctrl.$onInit = $onInit
  $ctrl.agregar = agregar
  $ctrl.cancelar = cancelar
  $ctrl.descargar = descargar
  $ctrl.omitir = omitir
  $ctrl.pausar = pausar

  function $onInit() {
    $ctrl.completado = false
    $ctrl.completados = 0
    $ctrl.data = $ctrl.data.reverse()
    $ctrl.documentos = []
    $ctrl.error = null
    $ctrl.generando = false
    $ctrl.lista = []
    $ctrl.omitidos = 0
    $ctrl.omitiendo = false
    $ctrl.pausado = false
    $ctrl.pendientes = [].concat($ctrl.data)
    $ctrl.progreso = 0
    $ctrl.status = 'Inicializando'
    $ctrl.total = $ctrl.pendientes.length
    $ctrl.zip = null

    avanzar()
  }

  function agregar(item) {
    if (item.error)
      $ctrl.omitidos++

    if (item.error && !$ctrl.omitiendo)
      $ctrl.error = item.error

    avanzar()
  }

  function avanzar() {
    $ctrl.completados = $ctrl.data.filter(function (item) {
      return item.completado
    })

    $ctrl.progreso = Math.round(($ctrl.completados.length / $ctrl.total) * 100)
    $ctrl.status = $ctrl.completados.length + ' de ' + $ctrl.total + ' colaboradores procesados'
      + ($ctrl.omitiendo ? ', ' + $ctrl.omitidos + ' omitidos' : '')

    if ($ctrl.pausado)
      return

    if ($ctrl.total === $ctrl.completados.length)
      return comprimir()

    if ($ctrl.error && !$ctrl.omitiendo)
      return

    if (!$ctrl.pendientes.length || ($ctrl.lista.length - $ctrl.completados.length) >= max)
      return

    $ctrl.lista.push($ctrl.pendientes.shift())
    $ctrl.generando = true
    $ctrl.completado = false

    avanzar()
  }

  function cancelar() {
    $ctrl.onClose()
  }

  function comprimir() {
    $ctrl.zip = null
    $ctrl.completado = true

    let documentos = $ctrl.data.reduce(function (carry, documento) {
      return (documento && angular.isArray(documento.documentos)) ? carry.concat(documento.documentos) : carry
    }, [])

    if (!documentos.length)
      return

    $ctrl.generando = false
    $ctrl.comprimiendo = true

    $zip().then(function (zip) {
      $ctrl.zip = documentos.reduce(function (zip, documento) {
        return zip.file(documento.filename, documento.content)
      }, zip)
    }).finally(function () {
      $ctrl.comprimiendo = false
    })
  }

  function descargar() {
    $ctrl.zip.generateAsync({
      type: 'blob',
      compression: 'DEFLATE',
      mimeType: 'application/zip',
    }).then(function (content) {
      $file.saveAs(content, $ctrl.archivo)
    })
  }

  function omitir() {
    $ctrl.omitiendo = true
    $ctrl.error = false
    avanzar()
  }

  function pausar(pausado) {
    $ctrl.pausado = pausado
    avanzar()
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/documentos/cfdi/generador/component.js